import { useEffect, useState } from "react";

import { DRAWERS } from "@app/modules/results/constants/pages";
import type { DrawerType } from "@app/types/drawer";
import * as WindowUtils from "@app/utils/window";

const DRAWER_PARAM = "open_drawer";

const DRAWERS_HANDLED_BY_REACT_ROUTER = [
  DRAWERS.TICKET_OPTIONS,
  DRAWERS.SEAT_SELECTION
];

function useCloseDrawerOnNav(drawer: DrawerType | null, onClose: () => void) {
  useEffect(() => {
    const listener = () => {
      if (!new URLSearchParams(window.location.search).get(DRAWER_PARAM)) {
        onClose();
      }
    };
    if (drawer && !DRAWERS_HANDLED_BY_REACT_ROUTER.includes(drawer.type)) {
      window.addEventListener("popstate", listener);
    }
    return () => window.removeEventListener("popstate", listener);
  }, [drawer, onClose]);
}

export function useOpenDrawerOnNewDrawer(
  drawer: DrawerType | null,
  onClose: () => void
) {
  const [isDrawerOpen, setOpen] = useState(false);
  const closeDrawer = () => setOpen(false);

  useCloseDrawerOnNav(drawer, onClose);

  useEffect(() => {
    const open = !!drawer;
    setOpen(open);

    // Ticket options & seat selection drawer navigation is handled by
    // react router - no need to push in history again.
    if (open && !DRAWERS_HANDLED_BY_REACT_ROUTER.includes(drawer.type)) {
      WindowUtils.pushToHistory({ [DRAWER_PARAM]: drawer.type });
    }
  }, [drawer]);

  return { isDrawerOpen, closeDrawer };
}
